import {
  FOLDERS,
  type Folder,
} from '@seen/core/models/document-references/folder'

export const useFolders = (): Folder[] => FOLDERS
